export default __webpack_public_path__ + "fa-solid-900.ttf";